<!--
 * @Date: 2022-09-28 17:36:33
 * @LastEditors: shikexin shikexin0116@163.com
 * @LastEditTime: 2022-10-19 15:38:10
 * @description: description
-->
<template>
  <div :class="$style.senseOfWorth">
    <div :class="$style.titleImg"></div>
    <div :class="$style.title">{{ info.title }}</div>

    <div
      :class="$style.contentInfo"
      v-for="(item, index) in info.contentMobile"
      :key="index"
    >
      <div :class="$style.contentImg" />
      <div
        :class="$style.contentBox"
        v-for="(info, index) in item"
        :key="index"
      >
        <div :class="$style.itemBox">
          <div :class="$style.contentLabel">{{ info.label }}</div>
        </div>
        <div :class="$style.itemContent">
          {{ info.info }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'aboutus-sense-of-worth',
  props: {
    info: Object
  }
}
</script>

<style lang="scss" module>
.senseOfWorth {
  position: relative;
  padding: 51px 20px 0;

  .titleImg {
    position: absolute;
    top: 21px;
    left: 20px;
    width: 112px;
    height: 98px;
    background-repeat: no-repeat;
    background-image: url("../../../assets/img/aboutus/mobile/sense.of.worth/title-img.png");
    background-size: 112px 98px;
  }

  .title {
    height: 28px;
    margin-bottom: 30px;
    text-align: center;
    line-height: 28px;
    font-size: 20px;
    font-weight: 500;
    color: #404040;
  }

  .contentInfo {
    position: relative;
    box-sizing: border-box;
    margin: 0 auto 20px;
    padding: 22px 30px;
    background: linear-gradient(139deg, #FFF5E7 0%, #FFFFFF 100%);
    box-shadow: 0px 8px 32px 0px rgba(206,211,226,0.24), inset 1px 1px 0px 0px #FFFFFF;
    border-radius: 6px;
  }

  .contentImg {
    position: absolute;
    top: 0;
    right: 0;
    width: 222px;
    height: 189px;
    background-repeat: no-repeat;
    background-image: url("../../../assets/img/aboutus/mobile/sense.of.worth/content-bg.png");
    background-size: 222px 189px;
  }

  .contentBox {
    padding-bottom: 16px;

    &:last-child {
      padding-bottom: 0;
    }
  }

  .itemBox {
    height: 22px;
    margin-bottom: 8px;
    text-align: center;
    line-height: 22px;
    font-weight: 500;
    color: #333333;
    font-size: 16px;
  }

  .contentLabel {
    height: 22px;
    line-height: 22px;
    font-size: 16px;
    font-weight: 500;
    color: #333333;
  }

  .itemContent {
    line-height: 26px;
    font-size: 14px;
    font-weight: 300;
    color: #404040;
  }
}
</style>
